module.exports = __webpack_public_path__ + "img/selected7-min.72914758.png";